import req from "@/assets/js/axios"
export default {

// 所有园区 部分
    /*获取热门空间*/
    getHotMeetings: (params) => {
        return req.apiAxios('GET', '/meeting/MeetingController/getHotMeetings', params);
    },
    /*获取热门园区*/
    getHotIncubators: (params) => {
        return req.apiAxios('GET', '/incubator/IncubatorController/getHotIncubators', params);
    },
    /*条件查询园区列表*/
    getIncubators: (params) => {
        return req.apiAxios('POST', '/incubator/IncubatorController/getIncubators', params);
    },
    /*园区VR*/
    incubatorsVR: (params) => {
        return req.apiAxios('POST', '/business/vr/BVrController/tour', params);
    },
    /*查询当前用户切换后的园区*/
    getIncubatorsInfo: (params) => {
        return req.apiAxios('POST', '/incubator/IncubatorController/starry-security/getInfo', params);
    },
    // 获取首页热门拼购
    getHotGroupBuy: (params) => {
        return req.apiAxios('POST', '/groupbuy/GroupBuyController/getHotGroupBuy', params)
    },
    //查询拼购详情
    getGroupBuys: (params) => {
        return req.apiAxios('POST', '/groupbuy/GroupBuyController/getGroupBuys', params)
    },
    /* 获取园区活动 */
    getActives: (params) => {
        return req.apiAxios('POST', '/active/ActiveController/getActives', params)
    },
    /* 获取首页热门活动 */
    getHotActive: (params) => {
        return req.apiAxios('POST', '/active/ActiveController/getHotActive', params)
    },
    /* 获取轮播图 */
    getNews: (params) => {
        return req.apiAxios('POST', '/news/NewsController/getNews', params)
    },
    /* 查询收藏列表 */
    getFrontCollections: (params) => {
        return req.apiAxios('POST', '/collection/CollectionController/starry-security/getFrontCollections', params)
    },
    /* 添加收藏 */
    createFrontCollection: (params) => {
        return req.apiAxios('POST', '/collection/CollectionController/starry-security/createFrontCollection', params)
    },
    /* 删除收藏 */
    updateFrontCollection: (params) => {
        return req.apiAxios('POST', '/collection/CollectionController/starry-security/updateFrontCollection', params)
    },
    /* 撤回认证 */
    withdrawAuthenticate: (params) => {
        return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateController/starry-security/withdrawAuthenticate', params)
    },
    /* 获取全部园区列表不带分页 */
    getList: (params) => {
        return req.apiAxios('POST', '/incubator/IncubatorController/getList', params)
    },
    /* 预约看房 */
    visitHouse: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController/starry-security/visitHouse', params)
    },
    /* 园区预约 */
    reservationVisit: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController/starry-security/reservationVisit', params)
    },
    /* 查询用户认证的企业（企业/员工） */
    // getUserEnterprise: (params) => {
    //     return req.apiAxios('POST', '/bussiness/enterprise/BEnterpriseController/starry-security/getUserEnterprise', params)
    // },
    /* 取消看房 */
    cancelVisit: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController//starry-security/cancelVisit', params)
    },
    /* 创建活动报名 */
    createActiveSignFromLoginKey: (params) => {
        return req.apiAxios('POST', '/activeSign/ActiveSignController/starry-security/createActiveSignFromLoginKey', params)
    },

// 个人中心认证部分
    /** 企业认证*/
    saveOrSubmitAuthenticate: (params) => {
        return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateController/starry-security/saveOrSubmitAuthenticate', params);
    },
    /** 条件查询认证（前台）*/
    getFrontAuthenticates: (params) => {
        return req.apiAxios('POST', '/authenticate/AuthenticateController/starry-security/getFrontAuthenticates', params);
    },
    /** 查询用户认证的企业*/
    getUserEnterprise: (params) => {
        return req.apiAxios('POST', '/bussiness/enterprise/BEnterpriseController/starry-security/getUserEnterprise', params);
    },
    /** 条件查询企业*/
    getEnterprises: (params) => {
        return req.apiAxios('POST', '/enterprise/EnterpriseController/getEnterprises', params);
    },
    /** 设置用户默认企业*/
    setUserDefaultEnterprise: (params) => {
        return req.apiAxios('POST', '/bussiness/enterprise/BEnterpriseController/starry-security/setUserDefaultEnterprise', params);
    },
    /** 设置默认企业和园区*/
    setUserDefaultIncubator: (params) => {
        return req.apiAxios('POST', '/bussiness/incubator/BIncubatorController/starry-security/setUserDefaultIncubator', params);
    },
    /** 切换当前企业和园区*/
    setUserSelectIncubator: (params) => {
        return req.apiAxios('POST', '/bussiness/incubator/BIncubatorController/starry-security/setUserSelectIncubator', params);
    },
    /** 根据企业查询园区*/
    getUserIncubator: (params) => {
        return req.apiAxios('POST', '/bussiness/incubator/BIncubatorController/starry-security/getUserIncubator', params);
    },
    /** 条件查询身份认证*/
    getAuthenticateEmployees: (params) => {
        return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateEmployeeController/starry-security/getAuthenticateEmployees', params);
    },
    /** 新增员工认证*/
    saveOrSubmitAuthenticateEmployee: (params) => {
        return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateEmployeeController/starry-security/saveOrSubmitAuthenticateEmployee', params);
    },
    /** 员工认证中通过园区校验企业名称*/
    checkEnterprise: (params) => {
        return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateEmployeeController/starry-security/checkEnterprise', params);
    },
    /** 撤回员工身份认证*/
    withdrawAuthenticateEmployee: (params) => {
        return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateEmployeeController/starry-security/withdrawAuthenticateEmployee', params);
    },
    /** 企业对员工身份认证审核*/
    // authenticateEmployeeApproval: (params) => {
    //     return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateEmployeeController/starry-security/authenticateEmployeeApproval', params);
    // },
    /** 企业入驻园区申请*/
    settled: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController/starry-security/settled', params);
    },
    /** 需求通用审核（取消园区入驻）*/
    demandApproval: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController//starry-security/demandApproval', params);
    },
    getFrontAuthenticateEmployee: (params) => {
        return req.apiAxios('POST', '/authenticateEmployee/AuthenticateEmployeeController/starry-security/getFrontAuthenticateEmployee', params);
    },
    // 新项目入驻认证
    saveOrSubmitEnterprise: (params) => {
        return req.apiAxios('POST', '/bussiness/enterprise/BEnterpriseController/starry-security/saveOrSubmitEnterprise', params);
    },
      // 企业查询填报状态（统计列表）
    getStatisticByEnterprise: (params) => {
        return req.apiAxios('POST', '/bussiness/enterprisestatistic/BEnterpriseStatisticController/starry-security/getStatisticByEnterprise', params);
    },
      // 条件查询企业提交统计（统计详情）
    getEnterpriseStatistic: (params) => {
        return req.apiAxios('POST', '/enterprisestatistic/EnterpriseStatisticController/starry-security/getEnterpriseStatistic', params);
    },
      // 企业操作填报(统计表单)
    approvalEnterpriseStatistic: (params) => {
        return req.apiAxios('POST', '/bussiness/enterprisestatistic/BEnterpriseStatisticController/starry-security/approvalEnterpriseStatistic', params);
    },
      // 新增团队人员（新项目入驻）
    createExtend: (params) => {
        return req.apiAxios('POST', '/extend/ExtendController/starry-security/createExtend', params);
    },
      // 更新团队人员（新项目入驻）
    updateExtend: (params) => {
        return req.apiAxios('POST', '/extend/ExtendController/starry-security/updateExtend', params);
    },
      // 删除团队人员（新项目入驻）
    deleteExtend: (params) => {
        return req.apiAxios('POST', '/extend/ExtendController/starry-security/deleteExtend', params);
    },
      // 查询团队人员（新项目入驻）
    getExtends: (params,tmp) => {
        tmp = tmp || false;
        return req.apiAxios('POST', '/extend/ExtendController/getExtends', params,tmp);
    },
    // 条件查询合同（前台）
    getContract: (params) => {
        return req.apiAxios('POST', '/business/contract/BContractController/starry-security/getContract', params);
    },
    // 条件查询合同单元关联用户关联(前台)
    getContractMeetings: (params) => {
        return req.apiAxios('POST', '/intermediate/contractmeeting/ContractMeetingController/starry-security/getContractMeetings', params);
    },
//活动报名部分

    /* 我的报名列表(新) */
    getActiveSigns: (params) => {
        return req.apiAxios('POST', '/activeSign/ActiveSignController/starry-security/getActiveSigns', params);
    },
     /* 我的报名列表 */
     getDemands: (params) => {
        return req.apiAxios('POST', '/demand/DemandController/starry-security/getDemands', params);
    },
    /* 添加需求 */
    joinActive: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController/starry-security/joinActive', params);
    },
    /* 取消报名 */
    cancelActive: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController/starry-security/cancelActive', params);
    },

//会议室部分
    /* 办公室预定记录 */
    getFontMeetingOrders: (params) => {
        return req.apiAxios('POST', '/meetingorder/MeetingOrderController/starry-security/getFontMeetingOrders', params);
    },
    /* 按日期查找会议室的空闲时间 */
    getMeetingFreeTime: (params) => {
        return req.apiAxios('POST', '/business/meetingorder/BMeetingOrderController/starry-security/getMeetingFreeTime', params);
    },
    /* 预定会议室列表 */
    getFontMeetings: (params) => {
        return req.apiAxios('POST', '/meeting/MeetingController/getFontMeetings', params);
    },
    /* 前台预定会议室 */
    orderMeeting: (params) => {
        return req.apiAxios('POST', '/business/meetingorder/BMeetingOrderController/starry-security/orderMeeting', params);
    },
    /* 取消预定会议室 */
    cancelMettingOrder: (params) => {
        return req.apiAxios('POST', '/business/meetingorder/BMeetingOrderController/starry-security/cancelOrder', params);
    },

//加班部分

    //创建加班申请
    createOvertimeApply: (params) => {
        return req.apiAxios('POST', '/overtimeapply/OvertimeApplyController/starry-security/createFrontOvertimeApply', params)
    },
    //查询加班申请记录
    getFontOvertimeApplys: (params) => {
        return req.apiAxios('POST', '/overtimeapply/OvertimeApplyController/starry-security/getFontOvertimeApplys', params)
    },
    //取消加班申请
    cancelOvertimeApply: (params) => {
        return req.apiAxios('POST', '/bussiness/overtimeapply/BOvertimeApplyController/starry-security/cancel', params)
    },

//园区公告部分
    //获取园区公告
    // getNews:(params)=>{
    // return req.apiAxios('POST','/news/NewsController/getNews',params)
    // },
    // 获取热门园区
    getHotNews:(params)=>{
        return req.apiAxios('POST','/news/NewsController/getHotNews',params)
    },
// 园区缴费部分
    //查询缴费记录
    getFontCosts: (params) => {
        return req.apiAxios('POST', '/cost/CostController/starry-security/getFontCosts', params)
    },
    // 上传缴费凭证
    pay:(params)=>{
        return req.apiAxios("POST",'/bussiness/cost/BCostController/starry-security/pay',params)
    },

// 拼购部分
     /** 获取拼购列表 */
     getPurchaseGroupBuys: (params) => {
        return req.apiAxios('POST', '/groupbuy/GroupBuyController/getGroupBuys', params)
    },
    /** 发起拼购 */
    createGroupBuy: (params) => {
        return req.apiAxios('POST', '/groupbuy/GroupBuyController/starry-security/createFrontGroupBuy', params)
    },
    //收藏拼购
    // createFrontCollection: (params) => {
    //     return req.apiAxios('POST', '/collection/CollectionController/starry-security/createFrontCollection', params)
    // },
    // 取消收藏
    deleteFrontCollection: (params) => {
        return req.apiAxios("POST", '/collection/CollectionController/starry-security/deleteFrontCollection', params)
    },
    //获取我参与的拼购
    getGroupBuyDemand: (params) => {
        return req.apiAxios('POST', '/bussiness/demand/BDemandController/starry-security/getGroupBuyDemand', params)
    },
    //参与拼购
    creatGroupBuyDemand: (params) => {
        return req.apiAxios("POST", '/bussiness/demand/BDemandController/starry-security/creatGroupBuyDemand', params)
    },
    getInfo: (params) => {
        return req.apiAxios("POST", '/incubator/IncubatorController/starry-security/getInfo', params)
    },
    //取消发起拼购
    cancelLaunch: (params) => {
        return req.apiAxios("POST", '/bussiness/groupbuy/BGroupBuyController/starry-security/cancel', params)
    },
    //取消参与拼购
    cancelJoin: (params) => {
        return req.apiAxios("POST", '/bussiness/demand/BDemandController/starry-security/cancelGroupBuyDemand', params)
    },

// 报修部分

      //查询报修申请记录
      getFrontRepairApply:(params)=>{
        return req.apiAxios('POST','/repairapply/RepairApplyController/starry-security/getFrontRepairApply',params)
    },
    //创建报修申请
    createFrontRepairApply:(params)=>{
        return req.apiAxios('POST','/repairapply/RepairApplyController/starry-security/createFrontRepairApply',params)
    },
    //取消报修申请
    cancelRepairApply:(params)=>{
        return req.apiAxios("POST",'/bussiness/repairapply/BRepairApplyController/starry-security/cancel',params)
    },
    //添加报修评论
    createFrontEvaluate:(params)=>{
        return req.apiAxios("POST",'/bussiness/repairapply/BRepairApplyController/starry-security/evaluate',params)
    },
    // 查看报修评价
    getFrontEvaluates:(params)=>{
        return req.apiAxios("POST","/evaluate/EvaluateController/starry-security/getFrontEvaluates",params)
    },

// 员工认证部分

     /** 获取员工认证列表 */
     getFrontEmployee: (params) => {
        return req.apiAxios('POST', '/employee/EmployeeController/starry-security/getFrontEmployee', params)
    },
    /* 员工管理操作 */
    authenticateEmployeeApproval: (params) => {
        return req.apiAxios('POST', '/bussiness/authenticate/BAuthenticateEmployeeController/starry-security/authenticateEmployeeApproval', params)
    },
    // 查询当前用户切换的员工身份
    getEmployee:(params)=>{
        return req.apiAxios("GET",'/employee/EmployeeController/starry-security/getInfo',params)
    },

// 访客部分

    /** 获取访问申请列表 */
    getFrontVisitorApply:(params) => {
        return req.apiAxios('POST','/visitorapply/VisitorApplyController/starry-security/getFrontVisitorApply',params)
    },
    /** 创建访问申请记录 */
    createFrontVisitorApply:(params) => {
        return req.apiAxios('POST','/visitorapply/VisitorApplyController/starry-security/createFrontVisitorApply',params)
    },
    /** 更新访问申请列表 */
    updateFrontVisitorApply:(params) => {
        return req.apiAxios('POST','/visitorapply/VisitorApplyController//starry-security/updateFrontVisitorApply',params)
    },
    /* 访客申请取消 */
    cancel:(params) => {
        return req.apiAxios('POST','/bussiness/visitorapply/BVisitorApplyController/starry-security/cancel',params)
    },

//个人信息部分
    // 获取用户当前选择的企业
    getEnterpriseInfo:(params)=>{
        return req.apiAxios("POST",'/enterprise/EnterpriseController/starry-security/getInfo',params)
    },
    pushDemand:(params)=>{
        return req.apiAxios("POST",'/demand/DemandController/starry-security/pushDemand',params)
    },

    //服务商认证
    saveOrSubmitBService:(params)=>{
        return req.apiAxios("POST",'/bussiness/enterprise/BEnterpriseController/starry-security/saveOrSubmitBService',params)
    },
    //服务商认证
    saveOrSubmitNBService:(params)=>{
        return req.apiAxios("POST",'/bussiness/enterprise/BEnterpriseController/starry-security/saveOrSubmitNBService',params)
    },

}
